import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogPaper: {
    margin: 'auto',
  },
  dialogContent: {},
  nameBlock: {
    marginBottom: '8px',
  },
  formItem: {
    paddingBottom: '8px',
  },
  formLabel: {
    marginBottom: '4px',
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
    },
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  radioButton: {
    alignItems: 'flex-start',
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  listItem: {
    marginTop: '8px',
  },
  foldersLoading: {
    display: 'block',
    marginTop: '8px',
  },
  accordionContainer: {},
  publicationName: {
    marginTop: '4px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
